<template>
  <div class="pageContainer">
    <div class="flex-column grow pt-2">
      <div
        v-if="kycStore.currentPosition === B2B_KYC_SUB_STEP.INTRO"
        class="flex-column align-items-center padding0 gap8 stretch"
      >
        <h1 class="h bold text-center">
          {{ $t("bnpl:intro_kyc.title") }}
        </h1>
        <p class="p-caption text-center gray600">
          {{ $t("bnpl:intro_kyc.description") }}
        </p>
      </div>

      <IdentiffKyc
        intro-kyc
        required
        :step-index="0"
        :reference="reference"
        :host-flow="hostFlow"
      />
    </div>
  </div>
</template>

<script setup>
import { B2B_KYC_SUB_STEP, KYC_HOST_FLOW } from "~~/utils/const";
import { useKycStore } from "~~/stores/kyc";

defineProps({
  /** Defaults to the route, which is where every application-shaped flow keeps it. */
  reference: {
    type: String,
    default: null,
  },
  hostFlow: {
    type: String,
    default: KYC_HOST_FLOW.BNPL_APPLICATION,
  },
});

const kycStore = useKycStore();
</script>

<style scoped></style>
